import { render, staticRenderFns } from "./change-address.scene.vue?vue&type=template&id=2ca892c4"
import script from "./change-address.scene.ts?vue&type=script&lang=ts&external"
export * from "./change-address.scene.ts?vue&type=script&lang=ts&external"
import style0 from "./change-address.style.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VProgressCircular,VSnackbar})
